import AppRouting from './AppRouting';
import { ContextProvider } from './context';
import { GlobalErrorBoundary } from './modules/core/pages/GlobalErrorBoundary';
import { useConsent } from './modules/login/services/useConsent';
import { AppEnvLazy } from './shared/components/app-debug/AppEnvLazy';

function App() {
  useConsent();

  return (
    <GlobalErrorBoundary>
      <ContextProvider>
        <AppRouting />
      </ContextProvider>
      <AppEnvLazy />
    </GlobalErrorBoundary>
  );
}

export default App;
